import { DatePipe, NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { Subscription, filter } from 'rxjs';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { StoreSelectorToggleComponent } from '../store-selector-toggle/store-selector-toggle.component';
import { EmailFormComponent } from './email-form/email-form.component';

@Component({
  selector: 'app-footer',
  imports: [
    NgIf,
    NgFor,
    DatePipe,
    StoryblokDirective,
    RouterModule,
    DynamicModule,
    StoryblokDirective,
    RouterModule,
    StoryblokLinkDirective,
    EmailFormComponent,
    StoreSelectorToggleComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit, OnDestroy {
  date: Date = new Date();
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() theme: any;

  components: any;
  isPromo: boolean = false;
  private routerSub?: Subscription;

  constructor(
    private eRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });

    this.updateRouteState(this.router.url);

    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateRouteState(event.urlAfterRedirects || event.url);
      });
  }

  ngOnInit(): void {
    this.updateRouteState(this.router.url);
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  private updateRouteState(url?: string): void {
    if (!url) return;
    const cleanUrl = url.split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
    this.isPromo = cleanUrl === '/promo' || cleanUrl.startsWith('/promo/');

    if (this.isPromo) {
      this.renderer.addClass(this.eRef.nativeElement, 'promo');
    } else {
      this.renderer.removeClass(this.eRef.nativeElement, 'promo');
    }

    if (cleanUrl.includes('personaliser/')) {
      this.renderer.addClass(this.eRef.nativeElement, 'personaliser');
    } else {
      this.renderer.removeClass(this.eRef.nativeElement, 'personaliser');
    }

    this.cd.markForCheck();
  }
}
